import { getGmailOAuthRedirectUri } from "./oauthRedirectUri";

const PRODUCTION_GMAIL_REDIRECT_URI = "https://lessonlaunchpad.com/gmail-callback";
const GMAIL_REDIRECT_URI_STORAGE_KEY = "gmailSupportRedirectUri";

export function getGmailRedirectUri() {
  return getGmailOAuthRedirectUri();
}

export async function beginGmailSupportAuth(functions, httpsCallable) {
  const redirectUri = getGmailRedirectUri();
  sessionStorage.setItem(GMAIL_REDIRECT_URI_STORAGE_KEY, redirectUri);

  const beginFn = httpsCallable(functions, "gmailSupportBeginAuth");
  const response = await beginFn({ redirectUri });
  const authorizationUrl = response.data?.authorizationUrl;
  if (!authorizationUrl) {
    throw new Error("Gmail authorization could not be started.");
  }
  window.location.assign(authorizationUrl);
}

export function consumeStoredGmailRedirectUri() {
  const stored = sessionStorage.getItem(GMAIL_REDIRECT_URI_STORAGE_KEY);
  sessionStorage.removeItem(GMAIL_REDIRECT_URI_STORAGE_KEY);
  return stored || getGmailRedirectUri();
}

/** @deprecated Use getGmailRedirectUri() */
export const DEFAULT_GMAIL_REDIRECT_URI = PRODUCTION_GMAIL_REDIRECT_URI;
